import { render, staticRenderFns } from "./LectureList.vue?vue&type=template&id=fa477652&scoped=true&"
import script from "./LectureList.vue?vue&type=script&lang=js&"
export * from "./LectureList.vue?vue&type=script&lang=js&"
import style0 from "./LectureList.vue?vue&type=style&index=0&id=fa477652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa477652",
  null
  
)

export default component.exports